<template>
  <div>
    <posttrade-cont :options="options" v-transition></posttrade-cont>
  </div>
</template>

<script>
import PosttradeCont from './components/Content'
export default {
  name: 'PostTrade',
  components: {
    PosttradeCont
  },
  data () {
    return {
      options: []
    }
  },
  methods: {
    GetClassifyInfo () {
      this.axios.get('/ApiMeAddGood/FrontAddGood')
        .then(this.GetClassifyInfoSucc)
        .catch(this.GetClassifyInfoFail)
    },
    GetClassifyInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.options = JSON.parse(data.options)
      }
    },
    GetClassifyInfoFail (err) {
      // alert(err)
      console.log(err)
    }
  },
  mounted () {
    this.GetClassifyInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/post_trade/Posttrade.vue